module.exports = __webpack_public_path__ + "assets/ToolInfos.5caa324a0c3e7d84c7a985aaac189f2f.xml";


//////////////////
// WEBPACK FOOTER
// ./src/resources/localizable/ru-lproj/ToolInfos.xml
// module id = 1038
// module chunks = 0